<template>
  <div class="image-radio-group">
    <div v-for="option in options" :style="style" :key="option.value" class="image-radio-option" :class="{ disabled: disabled }" @click="handleClick(option.value)">
      <img :style="{ width: style.imgWidth, height: style.imgHeight, borderRadius: style.imgRadius }" :src="option.optionUrl" :alt="option.label" class="option-image" />
      <div class="option-label">{{ option.label }}</div>
      <input type="radio" :style="getSelectStyle" :disabled="disabled" :value="option.value" :checked="modelValue === option.value" class="radio-input" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { computeRatioPx } from '@/packages/plugins/utils'

const props = defineProps({
  modelValue: [String, Number],
  options: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean
  },
  style: {
    type: Object,
    default: () => {}
  }
})

const emit = defineEmits(['change', 'update:modelValue'])

// 获取选择框变量样式
const getSelectStyle = computed(() => {
  return {
    '--select-bg': props.style.selectBg,
    '--selected-bg': props.style.selectedBg,
    '--selected-mark': props.style.selectMark,
    '--border-color': props.style.selectBorderColor,
    '--selected-width': computeRatioPx(16),
    '--selected-height': computeRatioPx(16),
    border: `${computeRatioPx(2)} solid var(--border-color)`,
    '--select-width': computeRatioPx(28),
    '--select-height': computeRatioPx(28),
    '--selected-margin': computeRatioPx(4)
  }
})

const handleClick = (value) => {
  if (!props.disabled) {
    emit('change', value)
    emit('update:modelValue', value)
  }
}
</script>

<style scoped>
.image-radio-group {
  display: flex;
  flex-direction: column;
  /* gap: 0.8571rem; */
}

.image-radio-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s;
  width: max-content;
  max-width: 100%;
  box-sizing: border-box;
}

/* .image-radio-option:hover {
  border-color: #409eff;
} */

/* .image-radio-option.selected {
  border-color: #409eff;
  background-color: #f0f7ff;
} */

.image-radio-option.disabled {
  cursor: not-allowed;
  border-color: #ccc;
  background-color: #f5f5f5;
}

.image-radio-option.disabled .radio-input {
  cursor: not-allowed;
}

.image-radio-option.disabled:hover {
  border-color: #ccc;
}

.option-image {
  width: 100%;
  height: 5.7143rem;
  object-fit: cover;
  border-radius: 0.2857rem;
}

.option-label {
  text-align: center;
  overflow-wrap: break-word;
  white-space: normal;
  /* width: 100%; */
  padding: 0 0.2857rem;
}

.radio-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  position: relative;
  cursor: pointer;
  border-radius: 50%;
  background: var(--select-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--select-width);
  height: var(--select-height);
  margin: 0;
}

.radio-input:checked {
  width: auto;
  height: auto;
}

.radio-input:checked::before {
  content: '';
  display: block;
  background-color: var(--selected-bg);
  width: var(--selected-width);
  height: var(--selected-height);
  border-radius: 50%;
  position: relative;
  margin: var(--selected-margin);
}
</style>
